import { useFormatDetector } from './hooks'

const FormatDetectorPlugin = () => {
  useFormatDetector()

  return null
}

export default FormatDetectorPlugin
